/* istanbul ignore file */
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import NotFound from '../views/NotFound'

import scores from '@/modules/Scores/routes'
import bcm from '@/modules/BlueprintContentManager/routes'
import activities from '@/modules/Activities/routes'
import profile from '@/modules/Profile/routes'
import Entitlements from '@/modules/Entitlements/routes'
import Assets from '@/modules/AssetManagement/routes'
import Services from '@/modules/Services/routes'
import surveys from '@/modules/Surveys/routes'

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/redirect',
    name: 'redirect',
    redirect: '/login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/accounts/details/:id',
    name: 'accountDetails',
    component: () => import('../views/Accounts/AccountDetails'),
    meta: {
      auth: true,
      can: { assessment: 'read' }
    },
    props: true
  },
  {
    path: '/accounts/create',
    name: 'createAccounts',
    component: () => import('../views/Accounts/Create'),
    meta: {
      auth: true,
      can: { assessment: 'read' }
    }
  },
  {
    path: '/accounts/search',
    name: 'searchAccounts',
    component: () => import('../views/Accounts/Search'),
    meta: {
      auth: true,
      can: { assessment: 'read' }
    }
  },
  {
    path: '/settings/task-types',
    name: 'task-types',
    component: () => import('../views/Settings/TaskTypes'),
    meta: {
      auth: true,
      can: { task: 'read' }
    }
  },
  {
    path: '/settings/assessment-configs',
    name: 'assessment-configs',
    component: () => import('../views/Settings/AssessmentConfigs'),
    meta: {
      auth: true,
      can: { task: 'read' }
    }
  },
  {
    path: '/slots',
    name: 'slots',
    component: () => import('../views/SlotsEditor'),
    meta: {
      auth: true,
      can: { schedule: 'read' }
    }
  },
  ...scores,
  ...bcm,
  ...activities,
  ...Assets,
  ...profile,
  ...Entitlements,
  ...Services,
  ...surveys,
  {
    path: '*',
    component: NotFound
  }
]
